export { default as BulkImport } from './page'


// WEBPACK FOOTER //
// ./src/pages/bulkImport/index.js